import "jquery.autocomplete";
$(function () {
    $("._page-inspiracoes").each(function () {
        const page = $(this);

        page.find("input").autocomplete({
            searchEverywhere: true,
            appendChars: "",
            onSelect: () => {
                page.find("form").trigger("submit");
            },
            lookup: window._inspiracoesAutoComplete,
        });
    });
});
